<template>
  <div>
    <section class="mbr-section mbr-parallax-background" id="content5-i" data-rv-view="17"
             style="background-image: url(assets/images/fazenda-732x543.jpg); padding-top: 120px; padding-bottom: 120px;">

      <div class="mbr-overlay" style="opacity: 0.7; background-color: rgb(0, 0, 0);">
      </div>

      <div class="container">
        <h3 class="mbr-section-title display-2">{{ data.certificate }}</h3>
        <div class="lead">
          <p>
            {{ data.text }}
          </p>
        </div>
      </div>

      <div class="container">
        <div class="lead">
          <div>
            <div>
              <MapChart
                  :countryData="{
                                 'AU': 2,
                                 'DZ': 1,
                                 'DE': 1,
                                 'BB': 1,
                                 'CV': 1,
                                 'CA': 1,
                                 'CL': 1,
                                 'KR': 1,
                                 'EC': 1,
                                 'ES': 1,
                                 'US': 1,
                                 'GD': 1,
                                 'GT': 1,
                                 'GY': 1,
                                 'HT': 1,
                                 'NL': 1,
                                 'HN': 1,
                                 'MU': 1,
                                 'JM': 1,
                                 'MR': 1,
                                 'NZ': 1,
                                 'PA': 1,
                                 'DO': 1,
                                 'LC': 1,
                                 'SX': 1,
                                 'SN': 1,
                                 'TW': 1,
                                 'TT': 1,
                                 'FR': 2,
                                 'PT': 1,
                                 'CG': 1,
                                 'AE': 1,
                                 'BE': 1
                              }"
                  highColor="#005F32"
                  lowColor="#005F32"
                  countryStrokeColor="#909090"
                  defaultCountryFillColor="#dadada"
                  :LangUser="language"
                  :showLegendContent=false
              />

            </div>
          </div>
        </div>
      </div>

    </section>
  </div>
</template>

<script>
import MapChart from 'vue-chart-map'

export default {
  name: "Exportation",
  components: {MapChart},
  props: {
    msg: String
  },
  data() {
    return {
      language: {},
      data: '',
      pt: {
        certificate: 'Exportação',
        text: 'Com a crescente demanda do mercado externo e visando expandir e aprimorar nossos produtos e marca, iniciamos nossas operações de comércio exterior no segundo semestre de 2016, concretizando uma das primeiras exportações ainda no mesmo ano. \n' +
            'Em 2017 já marcávamos presença na Ásia, América Central, África e União Europeia e logo iniciamos a nossa participação efetiva em feiras internacionais e rodadas de negócios.\n' +
            'Atualmente presentes em mais de 30 países buscamos crescimento contínuo com excelência em qualidade para atender as demandas e exigências do mercado internacional.\n'
      },
      en: {
        certificate: 'Export',
        text: 'With the growing demand from the foreign market and aiming to expand and improve our products and brand, we started our international operations in the second half of 2016 achieving one of the first exports in the same year. In 2017 we were already present in Asia, Central America, Africa and the European Union and started our effective participation in international trade shows.\n' +
            'Currently present in more than 30 countries, we seek continuous growth with excellence in quality to meet the demands and requirements of the international market.\n'
      },
      es: {
        certificate: 'Exportación',
        text: 'Con la creciente demanda del mercado exterior y con el objetivo de ampliar y \n' +
            'perfeccionar nuestros productos y marca, iniciamos nuestras operaciones de comercio exterior en el segundo semestre de 2016, logrando una de las primeras exportaciones en el mismo año.\n' +
            'En 2017 ya estábamos presentes en Asia, Centroamérica, África y la Unión Europea y pronto iniciamos nuestra participación efectiva en ferias internacionales y ruedas de negocios.\n' +
            'Presentes actualmente en más de 30 países, buscamos un crecimiento continuo con excelencia en la calidad para satisfacer las demandas y exigencias del mercado internacional\n'
      },
    }
  },
  mounted() {
    if (localStorage.language) {
      this.language = localStorage.language;
    } else {
      localStorage.setItem('language', 'pt')
      document.location.reload(true);
    }
    if (this.language == 'pt') {
      this.data = this.pt;
    }
    if (this.language == 'en') {
      this.data = this.en;
    }
    if (this.language == 'es') {
      this.data = this.es;
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.hero {
  padding-top: 7rem;
  width: 100%;
  height: 500px;
  text-align: left;
}

</style>
